
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

// import SchemaProfile from '@/components/schemas/SchemaProfile.vue';
import AllAccounts from '@/components/accounts/AllAccounts.vue';
import CreateAccount from '@/components/accounts/CreateAccount.vue';
import AccountProfileTile from '@/components/accounts/AccountProfileTile.vue';
import mwx from '@/store/modules/mediumwarex';
import accountx from '../store/modules/accountx';


@Component({
	components: {
		AllAccounts,
		CreateAccount,
		AccountProfileTile,
	},
})
export default class AccountManager extends Vue {
	public get currentAccount() {
		return accountx.currentAccount;
	}
}
